// extracted by mini-css-extract-plugin
export var container = "contact-module--container--ya-2J";
export var subTitle = "contact-module--subTitle--lfdl0";
export var title = "contact-module--title--d0OQY";
export var contactMsg = "contact-module--contactMsg--Fyjfb";
export var mail = "contact-module--mail--Nm22f";